import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import ReportModel from '@/models/reportModel'
import vehicleType from '@/models/vehicleTypeModel'
import SearchAreaModel from '@/models/SearchAreaModel'
import SearchAreaStatusEnum from '../enums/searchAreaStatusEnum'
import CommentModel from '@/models/commentModel'
import { RepositoryFactory, Repositories } from '../repositories/repositoryFactory'
import Vue from 'vue'

@Module({})
export default class ReportModule extends VuexModule {
    report: ReportModel = new ReportModel()
    loading: boolean = false

    @Mutation
    setStep (step: number) {
      this.report.step = step
    }

    @Mutation
    setVehicleType (input: vehicleType) {
      this.report.vehicleType = input
    }

    @Mutation
    setCheckOk (index: number) {
      this.report.vehicleType.searchAreas[index].status = SearchAreaStatusEnum.Accepted
    }

    @Mutation
    setCheckNOk (searchArea: SearchAreaModel) {
      searchArea.status = SearchAreaStatusEnum.Declined
    }

    @Mutation
    resetReport () {
      this.report = new ReportModel()
    }

    @Mutation
    setReportStatus (status: string) {
      this.report.vehicleType.status = status
    }

    @Mutation
    pushComment (input: any) {
      let newComment = new CommentModel()
      newComment.setText(input.comment.text)
      newComment.setImg(input.comment.img)
      input.area.comments.push(newComment)
    }

    @Mutation
    removeComment (index: number) {
      let currentArea = this.report.vehicleType.searchAreas[this.report.step - 2]
      Vue.delete(currentArea.comments, index)
    }

    @Mutation
    setLoading (loading: boolean) {
      this.loading = loading
    }

    @Action({ commit: 'setStep' })
    updateStep (step: number): number {
      return step
    }

    @Action({})
    updateVehicleType (type: vehicleType): any {
      type.shuffleAreas()
      return this.context.commit('setVehicleType', type)
    }

    @Action({})
    updateCheckOk (index: number): any {
      return this.context.commit('setCheckOk', index)
    }

    @Action({ commit: 'setCheckNOk' })
    decline (searchArea: SearchAreaModel): any {
      return searchArea
    }

    @Action({})
    saveComment (): any {
      let currentArea = this.report.vehicleType.searchAreas[this.report.step - 2]
      return this.context.commit('pushComment', { comment: this.composeComment, area: currentArea })
    }

    @Action({ commit: 'removeComment' })
    deleteComment (index: number): any {
      return index
    }

    @Action({ commit: 'setLoading' })
    toggleLoading (): any {
      return !this.loading
    }

    @Action({})
    sendReport (): any {
      this.context.dispatch('toggleLoading')
      const vm = this
      return RepositoryFactory.get(Repositories.Request).createRequest(this.report).then((report: any) => {
        console.log(report)
        this.context.dispatch('toggleLoading')
        vm.context.commit('resetReport')
      }, (error: any) => {
        this.context.dispatch('toggleLoading')
        // vm.context.commit('resetReport')
      })
    }

    get step (): number {
      return this.report.step
    }

    get reportVehicleType (): any {
      return this.report.vehicleType
    }

    get searchAreas (): Array<any> {
      return this.report.vehicleType.searchAreas
    }

    get composeComment (): CommentModel {
      return this.report.composeComment
    }

    get currentSearchArea (): SearchAreaModel {
      const currentStep = this.step
      const searchAreas = this.searchAreas

      return searchAreas[currentStep - 2]
    }


}
